import Divider from '@rio-cloud/rio-uikit/components/divider/Divider';

import { ModelYear } from '@/generated/GeneratedApiTypes';
import Header from './Header';

interface BasePanelProps {
    timestamp?: string;
    mileage?: number;
    isReadingNotPossible?: boolean;
    modelYear?: ModelYear;
    testId?: string;
    children: React.ReactNode;
}

const BasePanel = ({
    timestamp,
    mileage,
    isReadingNotPossible = false,
    modelYear,
    testId,
    children,
}: BasePanelProps) => (
    <div data-testid={testId}>
        <Header
            timestamp={timestamp}
            mileage={mileage}
            isReadingNotPossible={isReadingNotPossible}
            modelYear={modelYear}
        />

        <Divider spacing={10} />

        {children}
    </div>
);

export default BasePanel;
